import React from 'react';
import DOMPurify from 'dompurify';
import Emoji from './../Partials/Emoji';
import CommentsForm from './CommentsForm';

class Comment extends React.Component {
    constructor(props) {
        super(props);

        this.cookieName = window.btoa(`comments_liked`);

        this.state = {
            likes: this.props.comment.likes,
            liked: this.getLiked(),
            showForm: props.showForm,
            running: false,
        }

        this.onLike = this.onLike.bind(this);
        this.toggleReplyForm = this.toggleReplyForm.bind(this);
    }

    toggleReplyForm(e) {
        e.preventDefault();
        this.setState({
            showForm: !this.state.showForm,
        });
    }

    getLiked() {
        let likes = this.getCookieLikes();
        return likes[this.props.comment.id] ?? false;
    }

    getCookieLikes() {
        let likesJSON = window.Cookie.get(this.cookieName);
        if (typeof likesJSON == 'undefined') {
            return false;
        }
        return JSON.parse(likesJSON);
    }

    onLike() {
        let likes = this.getCookieLikes() || {};

        // Stop if we are awaiting a call already
        if (this.state.running) {
            return;
        }

        // Set running state to avoid spam clicking
        this.setState({
            running: true,
        });

        if (likes[this.props.comment.id]) {
            // Dislike
            delete likes[this.props.comment.id];
            this.doLike(likes, false);
        } else {
            // Like
            likes[this.props.comment.id] = true;
            this.doLike(likes);
        }
    }
    
    doLike(likes, like = true) {
        this.setState({
            likes: like ? this.state.likes + 1 : this.state.likes - 1,
            liked: like,
        });

        axios.post('/api/comment/like/', {
            comment_id: this.props.comment.id,
            like: like,
        })
        .then((response) => {
            window.Cookie.set(this.cookieName, JSON.stringify(likes), { expires: (365 * 10) });
        })
        .catch((error) => {
            console.error(error);
            this.setState({
                likes: ike ? this.state.likes - 1 : this.state.likes + 1,
                liked: !like,
            });
        })
        .finally(() => {
            this.setState({
                running: false,
            });
        });
    }

    // Idea from https://codepen.io/peterbartha/pen/BKxGPK
    calculateColor(email) {
        // Pastel rainbow
        const colors = [
            '#ffc1c2',
            '#ffcfc2',
            '#ffe5c3',
            '#fff1c1',
            '#f1fec2',
            '#d8fec2',
            '#c2ffc4',
            '#c3ffdd',
            '#c3feff',
            '#c2e7ff',
            '#c0d7ff',
            '#c3caff',
            '#d6c3ff',
            '#eac2ff',
            '#fcc3ff',
        ];

        let sum = 0;
        email.split('').forEach(
            character => sum += email.charCodeAt(character)
        );

        return colors[sum % colors.length];
    }

    render() {
        const postId = this.props.post.id;

        const replies = this.props.comment.replies && this.props.comment.replies.map((comment) => (
            <Comment key={comment.id} post={this.props.post} comment={comment} replyTo={this.props.comment} onFetchComments={this.props.onFetchComments} />
        )) || {};

        const verified = this.props.comment.by_user != 0;

        let authorUrlLink = '';
        if (this.props.comment.author_url) {
            // Create link for author URL
            authorUrlLink = this.props.comment.author_url;

            // Instagram link
            if (authorUrlLink.substring(0, 1) == '@') {
                authorUrlLink = `https://www.instagram.com/${authorUrlLink.substring(1)}/`;
            }

            // Prepend protocol to URL if not present
            if (!/^https?:\/\//i.test(authorUrlLink)) {
                authorUrlLink = 'https://' + authorUrlLink;
            }
        }

        // Wrap links in a tag (if verified user)
        if (verified) {
            this.props.comment.body = this.props.comment.body.replace(/([^">])(https?:\/\/[^\s]+)/, '$1<a href="$2" rel="nofollow ugc" target="_blank">$2</a>');
        }

        const sanitizeConfig = { ONLY_TAGS: ['a'], ADD_ATTR: ['target'] };

        return (
            <div className={`comment ${this.props.className ?? ''}${verified ? ' comment--verified' : ''}`}>
                <span id={`comment-${this.props.comment.id}`} className="anchor" />
                { this.props.comment.gravatar ? (
                    <img src={this.props.comment.gravatar} alt={`${this.props.comment.author_name} Gravatar`} className="comment__avatar" />
                ) : (
                    <svg className="comment__avatar comment__avatar--svg" width="30" height="30" viewBox="-50 -50 100 100" xmlns="http://www.w3.org/2000/svg">
                        <circle fill={this.calculateColor(this.props.comment.author_email)} r="50" />
                        <text fill="#ffffff" className="letter" textAnchor="middle" dominantBaseline="central">{this.props.comment.author_name.charAt(0)}</text>
                    </svg>
                )}
                <div className="comment__body">
                    <div className="comment__name">
                        { this.props.comment.author_name }

                        { verified && 
                        <Emoji type="check_circle" className="comment__verified" />
                        }

                        { this.props.replyTo && 
                        <span className="comment__reply-to">
                            <Emoji type="reply" />
                            { this.props.replyTo.author_name }
                        </span>
                        }
                    </div>
                    { this.props.comment.author_url && 
                        <div className="comment__url">
                            <a href={authorUrlLink} rel="nofollow ugc" target="_blank">{ this.props.comment.author_url }</a>
                        </div>
                    }
                    { verified ?
                        <div className="comment__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.comment.body, sanitizeConfig)}}>
                        </div>
                    :
                        <div className="comment__text">
                            { this.props.comment.body }
                        </div>
                    }
                </div>
                <div className="comment__bottom">
                    <a 
                        href={`https://${window.location.host}${this.props.post.url}?replytocom=${this.props.comment.id}#respond`} 
                        className="btn btn-primary btn-sm" onClick={this.toggleReplyForm}
                        rel="nofollow"
                        >
                            Svara
                        </a>
                        {
                            this.props.post.meta_data.hide_comment_likes != "1" &&
                            <button className={'btn btn-primary btn-sm' + (this.state.liked ? ' liked' : '')} onClick={this.onLike}>
                                <Emoji type="thumbs_up" />
                                { this.state.likes }
                            </button>
                        }
                </div>
                <div className="comment__details">
                    { this.props.comment.created_at }
                </div>
                { this.state.showForm && 
                    <div id={`reply-form-${this.props.comment.id}`} className="comments__form_area w-100">
                        <CommentsForm post={this.props.post} replyTo={this.props.comment} onFetchComments={this.props.onFetchComments} onToggleForm={this.toggleReplyForm} />
                    </div>
                }
                
                { replies.length > 0 &&
                    <div className={"comment__replies" + (this.props.replyTo ? ' comment__replies--deep' : '')}>
                        { replies }
                    </div>
                }
            </div>
        )
    }
}

export default Comment;